let base = window._env_.VUE_APP_ADMIN_HOST

export const getUnreadInboxMessageCount = () => {
  return axios.post(`${base}/admin_inbox_message/get_unread_inbox_messages`)
}

export const readAdminInboxMessage = (param) => {
  return axios.post(`${base}/admin_inbox_message/read`, param)
}

export const queryAdminInboxMessage = (params) => {
  return axios.post(`${base}/admin_inbox_message/query`, params)
}



// WEBPACK FOOTER //
// ./src/views/admin-inbox-message/admin-inbox-message.api.js